module.exports = __webpack_public_path__ + "noPermissions-image.55116f7ef53fff4a249e8fa341c44f05.hashedasset.svg";